import { createPinia } from 'pinia'
import type { App } from 'vue'
// import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const store = createPinia()
// store.use(piniaPluginPersistedstate)

export function setupStore(app: App<Element>) {
  app.use(store)
}

export * from './modules'

export { store }
